import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const INSIGHT_PATH = /^\/([^/]+)\/insight\/(\d+)\/?$/i;

function insightFromPath(pathname) {
    const match = String(pathname || '').match(INSIGHT_PATH);
    if (!match) return null;
    return { username: match[1], insightId: match[2] };
}

function isAndroid() {
    const ua = navigator.userAgent || '';
    const platform = (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '';
    if (/Win/i.test(platform) || /Windows/i.test(ua)) return false;
    if (/iPhone|iPad|iPod/i.test(ua)) return false;
    return /Android/i.test(ua) || /Android/i.test(platform);
}

export function openInsightInApp(username, insightId) {
    if (!isAndroid()) return;
    const path = `${username}/insight/${insightId}`;
    window.location.href = `intent://${path}#Intent;scheme=clowza;package=com.clowza.app;end`;
}

export default function OpenInsightInApp() {
    const location = useLocation();
    const insight = insightFromPath(location.pathname);
    const stayOnWeb = new URLSearchParams(location.search).get('web') === '1';

    useEffect(() => {
        const current = insightFromPath(location.pathname);
        if (!current || stayOnWeb || !isAndroid()) return undefined;
        const key = `clowza-open-insight-${current.username}-${current.insightId}`;
        try {
            if (sessionStorage.getItem(key)) return undefined;
            sessionStorage.setItem(key, '1');
        } catch (err) {
            return undefined;
        }
        const timer = setTimeout(() => openInsightInApp(current.username, current.insightId), 400);
        return () => clearTimeout(timer);
    }, [location.pathname, stayOnWeb]);

    if (!insight || !isAndroid()) return null;

    return (
        <div style={{
            position: 'sticky',
            top: 0,
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            padding: '12px 16px',
            background: '#1f6f62',
            color: '#fff',
        }}>
            <span style={{ fontSize: 14, lineHeight: 1.3 }}>
                Open this insight in the Clowza app
            </span>
            <button
                type="button"
                onClick={() => openInsightInApp(insight.username, insight.insightId)}
                style={{
                    border: 0,
                    borderRadius: 8,
                    padding: '8px 14px',
                    background: '#fff',
                    color: '#1f6f62',
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                }}
            >
                Open app
            </button>
        </div>
    );
}
